import { z } from 'zod/v4';
import { CAPA_ACTION_PRIORITY } from '../../constants.js';

const capaActionPriorityValues = Object.values(CAPA_ACTION_PRIORITY) as [
  string,
  ...string[],
];

export const QuickAddActionAssigneeSchema = z.object({
  id: z.string().min(1, 'Assignee user ID is required'),
  companyId: z.string().min(1, 'Assignee company ID is required'),
});

export const QuickAddActionReporterSchema = z.object({
  userId: z.string().min(1, 'User ID is required'),
  companyId: z.string().min(1, 'Company ID is required'),
});

export const QuickAddActionRequestSchema = z.object({
  capId: z.string().min(1, 'CAP ID is required').nullable().optional(),
  companyId: z.string().min(1, 'Company ID is required'),
  title: z.string().min(1, 'Title is required'),
  auditFindingId: z.string().nullable(),
  type: z.enum(['CA', 'PA']),
  assignees: z.array(QuickAddActionAssigneeSchema).optional(),
  reporters: z.array(QuickAddActionReporterSchema).optional(),
  impactAreaId: z.string().nullable().optional(),
  priority: z.enum(capaActionPriorityValues).optional(),
});
export type QuickAddActionRequest = z.infer<typeof QuickAddActionRequestSchema>;
